import { PollingIntervalGroups } from "apollo/constants";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import Link from "ds/components/Link";
import useOpenTofuMigrationSearchStacks from "shared/Stack/OpenTofuMigration/useSearchStacks";
import { OPEN_TOFU_MIGRATION_PATH } from "views/Account/OpenTofuMigration/constants";

import { DASHBOARD_WIDGETS_OPEN_TOFU_READY_TO_MIGRATE_VARIABLES } from "../constants";
import DashboardWidgetsOpenTofuMigrationStackList from "./StackList";

const DashboardWidgetsOpenTofuMigrationReadyToMigrateList = () => {
  const { entities, isLoading, error, refetch } = useOpenTofuMigrationSearchStacks({
    variables: DASHBOARD_WIDGETS_OPEN_TOFU_READY_TO_MIGRATE_VARIABLES,
    pollingGroup: PollingIntervalGroups.Dashboard,
  });

  return (
    <DashboardWidgetsOpenTofuMigrationStackList
      title="Ready to migrate"
      action={
        <Box align="center" gap="medium">
          <LinkButton variant="primary" size="small" to={OPEN_TOFU_MIGRATION_PATH}>
            Migrate
          </LinkButton>
          <Link href={OPEN_TOFU_MIGRATION_PATH}>See all</Link>
        </Box>
      }
      stacks={entities}
      isLoading={isLoading}
      hasError={!!error}
      errorText="Couldn’t load stacks ready to migrate. Please try to refresh or come back later."
      emptyTitle="Nothing ready to migrate"
      emptyCaption="Stacks eligible for migration will show up here."
      onRefetch={refetch}
    />
  );
};

export default DashboardWidgetsOpenTofuMigrationReadyToMigrateList;
